import { parseDuration, parseNumber, parseString } from '../utils';
import type { TraceWriteRequest } from '../api/TraceabilityRequestType';
import type { Trace } from '../type/Tool';
import type { Machine } from '../type/Machine';
import type { Material } from '../type/Material';
import type { MaterialLot } from '../type/MaterialLot';

export function buildTracePayload(
  formValues: Record<string, unknown>,
  toolId: string,
  _companyName: string
): TraceWriteRequest {
  const currentTrace: Trace = {
    toolId,
    totalMachiningDuration: parseDuration(formValues.duration_total),
    pieceMachiningDuration: parseDuration(formValues.duration_piece),

    machinedVolume: parseNumber(formValues.volume),
    machinedDistance: parseNumber(formValues.distance),
    machinedPieces: parseNumber(formValues.pieces),

    malround: parseNumber(formValues.malrond),
    operator: parseString(formValues.operator),
    operation: parseString(formValues.operation),

    machine: formValues.machine as Machine,
    material: formValues.material as Material,
    materialLot: (formValues.materialLot as MaterialLot | null) ?? null,

    lubType: formValues.lubType as string,
    lubBrand: parseString(formValues.lubBrand),

    holderType: parseString(formValues.holderType),
    holderBrand: parseString(formValues.holderBrand),

    clampingType: parseString(formValues.clampingType),
    clampingBrand: parseString(formValues.clampingBrand),

    ae: parseNumber(formValues['ae']),
    ap: parseNumber(formValues['ap']),
    vc: parseNumber(formValues['vc']),
    fz: parseNumber(formValues['fz']),

    toolState: {
      toolState: formValues.toolState as string,
      changeReason: Array.isArray(formValues.toolChange) ? (formValues.toolChange as string[]) : [],
      note: parseString(formValues.commentary),
    },

    createdAt: null,
    updatedAt: null,
  };

  return {
    trace: currentTrace,
  } as TraceWriteRequest;
}

export function useTraceFormBuilder() {
  return { buildTracePayload };
}
